export default __webpack_public_path__ + "static/media/light_rain.801e0486.png";